// src/firebase/config.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDzUlyFrgvHe_CYoRW8y7BIY_fZEQMJH6k",
  authDomain: "familypoints-96748.firebaseapp.com",
  projectId: "familypoints-96748",
  storageBucket: "familypoints-96748.firebasestorage.app",
  messagingSenderId: "824742340534",
  appId: "1:824742340534:web:8e30838bf3f257d7810317"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
